import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EDITORES_EM_CAMADA } from '@/app/editores-em-camada';
import { NovoAtendimento } from '@/features/atendimentos/componentes/NovoAtendimento';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  /** Aluno já escolhido, vindo da página dele. */
  alunoId: z.uuid().optional().catch(undefined),
  /** `aluno`: depois de criar, volta para a página do aluno (CA-03). */
  volta: z.enum(['aluno']).optional().catch(undefined),
});

/** Nova prescrição (spec 010, CA-02). */
export const Route = createFileRoute('/_autenticado/atendimentos/novo')({
  ...rotaDeTela('atendimentos.lista'),
  staticData: { tela: 'atendimentos.lista', titulo: 'Nova prescrição' },
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { alunoId, volta } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <NovoAtendimento
      alunoId={alunoId}
      editores={EDITORES_EM_CAMADA}
      aoTerminar={() => {
        if (volta === 'aluno' && alunoId !== undefined) {
          void navigate({
            to: '/alunos/$id',
            params: { id: alunoId },
            search: { aba: 'atendimentos' },
          });
        } else {
          void navigate({ to: '/atendimentos' });
        }
      }}
    />
  );
}
